<div gdColumns="repeat(auto-fill, minmax(250px, 1fr))" gdGap="10px" [formGroup]="form">
	<mat-form-field *ngIf="fieldsToShow?.showWorkOrderNumber">
		<input autocomplete="off" matInput placeholder="Work Order Number" formControlName="workOrderNumber"
			[matAutocomplete]="workOrderNumberAutocomplete" />
		<mat-autocomplete #workOrderNumberAutocomplete="matAutocomplete">
			<mat-option *ngFor="let value of filteredWorkOrderNumbers$ | async" [value]="value">
				{{ value }}
			</mat-option>
		</mat-autocomplete>
	</mat-form-field>
	<mat-form-field *ngIf="fieldsToShow?.showProjectManagerName">
		<input autocomplete="off" matInput placeholder="Project Manager Name" formControlName="projectManagerName"
			[matAutocomplete]="projectManagerNameAutocomplete" />
		<mat-autocomplete #projectManagerNameAutocomplete="matAutocomplete">
			<mat-option *ngFor="let value of filteredProjectManagerNames$ | async" [value]="value">
				{{ value }}
			</mat-option>
		</mat-autocomplete>
	</mat-form-field>
	<mat-form-field *ngIf="fieldsToShow?.showProjectNumber">
		<input autocomplete="off" matInput placeholder="Project Number" formControlName="projectNumber"
			[matAutocomplete]="projectNumberAutocomplete" />
		<mat-autocomplete #projectNumberAutocomplete="matAutocomplete">
			<mat-option *ngFor="let value of filteredProjectNumbers$ | async" [value]="value">
				{{ value }}
			</mat-option>
		</mat-autocomplete>
	</mat-form-field>
	<mat-form-field *ngIf="fieldsToShow?.showAgreementNumber">
		<input autocomplete="off" matInput placeholder="Agreement Number" formControlName="agreementNumber"
			[matAutocomplete]="agreementNumberAutocomplete" />
		<mat-autocomplete #agreementNumberAutocomplete="matAutocomplete">
			<mat-option *ngFor="let value of filteredAgreementNumbers$ | async" [value]="value">
				{{ value }}
			</mat-option>
		</mat-autocomplete>
	</mat-form-field>
	<mat-form-field *ngIf="fieldsToShow?.showUpFolderNumber">
		<input autocomplete="off" matInput placeholder="UP Folder Number" formControlName="upFolderNumber"
			[matAutocomplete]="upFolderNumberAutocomplete" />
		<mat-autocomplete #upFolderNumberAutocomplete="matAutocomplete">
			<mat-option *ngFor="let value of filteredUpFolderNumbers$ | async" [value]="value">
				{{ value }}
			</mat-option>
		</mat-autocomplete>
	</mat-form-field>
	<mat-form-field *ngIf="fieldsToShow?.showReferenceNumber">
		<input autocomplete="off" matInput placeholder="Reference Number" formControlName="referenceNumber"
			[matAutocomplete]="referenceNumberrAutocomplete" />
		<mat-autocomplete #referenceNumberrAutocomplete="matAutocomplete">
			<mat-option *ngFor="let value of filterReferenceNumbers$ | async" [value]="value">
				{{ value }}
			</mat-option>
		</mat-autocomplete>
	</mat-form-field>
	<mat-form-field *ngIf="fieldsToShow?.showNsActivityNumber">
		<input autocomplete="off" matInput placeholder="NS Activity Number" formControlName="nsActivityNumber"
			[matAutocomplete]="nsActivityNumberAutocomplete" />
		<mat-autocomplete #nsActivityNumberAutocomplete="matAutocomplete">
			<mat-option *ngFor="let value of filteredNsActivityNumbers$ | async" [value]="value">
				{{ value }}
			</mat-option>
		</mat-autocomplete>
	</mat-form-field>

	<mat-form-field *ngIf="fieldsToShow?.showNetworkOrServiceOrder">
		<mat-select formControlName="networkOrServiceOrder" disableOptionCentering="true"
			placeholder="Network/Service Order">
			<mat-option *ngFor="let type of networkOrServiceOrderTypes" [value]="type">
				{{ displayNetworkOrServiceOrder[type] }}
			</mat-option>
		</mat-select>
	</mat-form-field>
	<mat-slide-toggle *ngIf="fieldsToShow?.showIsSupervisorJob" formControlName="isSupervisorJob"
		labelPosition="before">Is Supervisor Job
	</mat-slide-toggle>
	<mat-slide-toggle *ngIf="fieldsToShow?.showIsThirdPartyJob" formControlName="isThirdPartyJob" labelPosition="before"
		class="custom-slider">Is Third Party Job
	</mat-slide-toggle>
	<mat-slide-toggle *ngIf="fieldsToShow?.showRequiresJobSetups" formControlName="requiresJobSetups"
		labelPosition="before">Requires Job Setups
	</mat-slide-toggle>
	<mat-form-field gdColumn="-1 / 1" *ngIf="fieldsToShow?.showTermsAndConditions">
		<textarea matInput formControlName="termsAndConditions" cdkTextareaAutosize #autosize="cdkTextareaAutosize"
			cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5" rpsharedAutofocus placeholder="Terms And Conditions">
		</textarea>
	</mat-form-field>
	<mat-form-field gdColumn="-1 / 1" *ngIf="fieldsToShow?.showProtection">
		<textarea matInput formControlName="protection" cdkTextareaAutosize #autosize="cdkTextareaAutosize"
			cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5" rpsharedAutofocus placeholder="Protection">
		</textarea>
	</mat-form-field>
</div>